import * as React from 'react';
import UserModel from 'src/model/user.model';
import './AccountMenu.scss';
import { Link } from 'react-router-dom';
import { canManageSubUsers } from 'src/utils/permissions';
import env from 'src/shared/env';

interface IAccountMenuProps {
  selected:
    | 'info'
    | 'ship'
    | 'card'
    | 'subusers'
    | 'password'
    | 'statement'
    | 'credit';
  userData: UserModel;
  onSelect(selected: string): void;
  location: any;
  match: any;
  t?: any;
}

class AccountMenu extends React.Component<IAccountMenuProps, any> {
  private getActiveClass(
    item:
      | 'info'
      | 'ship'
      | 'card'
      | 'subusers'
      | 'password'
      | 'statement'
      | 'credit'
      | 'updateinfo'
  ): string {
    return this.props.selected === item ? 'active' : '';
  }

  public componentDidMount = () => {
    const CURRENT_PATH = 2;
    const values = this.props.location.pathname.split('/');
    const location = values[CURRENT_PATH] ? values[CURRENT_PATH] : 'info';

    this.props.onSelect(location);
    this.getActiveClass(location);
  };

  public render() {
    const { t } = this.props;
    return (
      <div className="rp-accountmenu">
        <Link to={`${this.props.match.url}`} className="rp-accountmenu-link">
          <button
            className={`rp-accountmenu--item ${this.getActiveClass('info')}`}
            onClick={() => this.props.onSelect('info')}
          >
            <i className="rpds rpds-user" />
            <span>{t('accountMenuSidePanel.accountInfo')}</span>
          </button>
        </Link>

        <Link
          to={`${this.props.match.url}/ship`}
          className="rp-accountmenu-link"
        >
          <button
            className={`rp-accountmenu--item ${this.getActiveClass('ship')}`}
            onClick={() => this.props.onSelect('ship')}
          >
            <i className="rpds rpds-turn-sign" />
            <span>{t('accountMenuSidePanel.shippingAddress')}</span>
          </button>
        </Link>
        {env.REACT_APP_CREDIT_CC_CARD === 'true' && (
          <Link
            to={`${this.props.match.url}/card`}
            className="rp-accountmenu-link"
          >
            <button
              className={`rp-accountmenu--item ${this.getActiveClass('card')}`}
              onClick={() => this.props.onSelect('card')}
            >
              <i className="rpds rpds-credit-card" />
              <span>{t('accountMenuSidePanel.creditCards')}</span>
            </button>
          </Link>
        )}
        <Link
          to={`${this.props.match.url}/statement`}
          className="rp-accountmenu-link rp-accountmenu-statement"
        >
          <button
            className={`rp-accountmenu--item ${this.getActiveClass(
              'statement'
            )}`}
            onClick={() => this.props.onSelect('statement')}
          >
            <i className="rpds-chart" />
            <span>{t('accountMenuSidePanel.monthlyStatements')}</span>
          </button>
        </Link>
        {canManageSubUsers() && (
          <Link
            to={`${this.props.match.url}/subusers`}
            className="rp-accountmenu-link"
          >
            <button
              className={`rp-accountmenu--item ${this.getActiveClass(
                'subusers'
              )}`}
              onClick={() => this.props.onSelect('subusers')}
            >
              <i className="rpds rpds-credit-card" />
              <span>Manage subusers</span>
            </button>
          </Link>
        )}
        <Link
          to={`${this.props.match.url}/creditlimit`}
          className="rp-accountmenu-link"
        >
          <button
            className={`rp-accountmenu--item ${this.getActiveClass('credit')}`}
            onClick={() => this.props.onSelect('credit')}
          >
            <i className="rpds rpds-money-bag" />
            <span>{t('accountMenuSidePanel.creditLimitIncrease')}</span>
          </button>
        </Link>
        <Link
          to={`${this.props.match.url}/password`}
          className="rp-accountmenu-link"
        >
          <button
            className={`rp-accountmenu--item ${this.getActiveClass(
              'password'
            )}`}
            onClick={() => this.props.onSelect('password')}
          >
            <i className="rpds rpds-lock" />
            <span>{t('accountMenuSidePanel.manageMyPassword')}</span>
          </button>
        </Link>
        <Link
          to={`${this.props.match.url}/updateinfo`}
          className="rp-accountmenu-link"
        >
          <button
            className={`rp-accountmenu--item ${this.getActiveClass(
              'updateinfo'
            )}`}
            onClick={() => this.props.onSelect('updateinfo')}
          >
            <i className="rpds rpds-edit" />
            <span>
              {' '}
              {t('accountMenuSidePanel.updatePersonalInfo', {
                interpolation: { escapeValue: false }
              })}
            </span>
          </button>
        </Link>
      </div>
    );
  }
}

export default AccountMenu;
